import parse from "html-react-parser";
import { useState } from "react";
import Clouds from "../../Reusable/Clouds/Clouds.js";
import Icon from "../../Elements/Icon/Icon.tsx";
import Image from "components/Elements/Image/Image.tsx";
import ContactrUsForm from "./ContactUsForm/ContactrUsForm.js";
import Button, { ButtonAccessability } from "../../Elements/Button/Button.js";
import { useUser } from "../../../contexts/userContext/userContext.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { LinkToNewTab, LinkToPhone } from "components/Elements/Link/Link.js";

import "./ContactUs.scss";

const ContactUs = () => {
  const { getTextByKey, getLanguageCulture } = useContent();
  const { isSubscribed, isPro } = useUser();
  const [ifSuccess, setIfSuccess] = useState(false);
  const [hideForm, setHideForm] = useState(false);

  return (
    <div className="contact-wrapper">
      <div className="contact-title-container">
        <div className="contact-text-page contact-us-sub-header">
          {getTextByKey("ContactUs_SubHeader_SystemStatus")
            ? parse(getTextByKey("ContactUs_SubHeader_SystemStatus"))
            : null}
        </div>
        <div className="title-divider"></div>
      </div>
      <div className="contact-us-form">
        <div className="contact-us-preform">
          <div className="contact-us-preform-title">
            {getTextByKey("contact-us-title")}
          </div>
          <div className="sub-title">
            {getTextByKey("contact-us-sub-title")}
          </div>
          <div>{parse(getTextByKey("contact-us-text"))}</div>
          <LinkToNewTab
            isNewTab={
              getLanguageCulture().split("-")[0] === "ru" ||
              getLanguageCulture().split("-")[0] === "ar"
                ? true
                : false
            }
            page="support"
            ariaLabel={getTextByKey("contact-us-button-text")}
          >
            <Button small>{getTextByKey("contact-us-button-text")}</Button>
          </LinkToNewTab>
          <div className="sub-title">
            {getTextByKey("other-issues-sub-title")}
          </div>
          <div>
            {getTextByKey("other-issues-text")}{" "}
            <ButtonAccessability
              onClick={() => setHideForm((prev) => !prev)}
              buttonClassName="open-form-text"
            >
              {getTextByKey("other-issues-contact-us")}
            </ButtonAccessability>
          </div>
        </div>
        {!ifSuccess ? (
          <div
            className={
              hideForm ? "contact-us-full-form" : "contact-us-full-form hidden"
            }
          >
            <div className="contact-by-phone">
              <h3>{getTextByKey("by-email")}</h3>
            </div>
            <ContactrUsForm {...{ setIfSuccess, hideForm, setHideForm }} />
            {isSubscribed() && !isPro() && (
              <div className="contact-by-phone">
                {/* Only for premium and business */}
                <h3>{getTextByKey("by-phone")}</h3>
                <div className="phone-number contact-field">
                  <span className="label-contact">
                    {getTextByKey("phone-number")}:
                  </span>
                  <span className="value-contact">
                    <LinkToPhone phone={getTextByKey("jumbomail-phone-number")}>
                      {getTextByKey("jumbomail-phone-number")}
                    </LinkToPhone>
                  </span>
                </div>
                <div className="address contact-field">
                  <span className="label-contact">
                    {getTextByKey("address")}:
                  </span>
                  <span className="value-contact">
                    {getTextByKey("jumbomail-address")}
                  </span>
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className="success-message contact-us-form">
            <div className="icon-success">
              <Icon name="check" ext="svg" blue />
            </div>
            <span>{getTextByKey("contact-support-success")}</span>
          </div>
        )}
        <div className="contact-us-phone-con">
          <Image
            className="contact-phone"
            name="contact-us-phone"
            ext="jpg"
            alt=""
            title=""
          />
        </div>
      </div>
      <Clouds type="" />
    </div>
  );
};

export default ContactUs;
